import { selectBuildingsWhichProducesResourceIdAvailable } from "../selectors/selectBuildingsWhichProducesResourceIdAvailable";
import { createPathSelectBuildingMaxLevel } from "./createPathSelectBuildingMaxLevel";
export var pathSelectBuildingMaxLevelByResourceId = function (action, state$, deps) {
    return createPathSelectBuildingMaxLevel(function () {
        var state = state$.value;
        var resourceId = action.taskType.resourceId;
        return selectBuildingsWhichProducesResourceIdAvailable(state, resourceId);
    })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/path/pathSelectBuildingMaxLevelByResourceId.ts
// module id = 900
// module chunks = 3